export const SELF_VIDEO_ID = 'ZOOM_WEB_SDK_SELF_VIDEO';


export const SHARE_CANVAS_ID = 'ZOOM_WEB_SDK_SHARER_CANVAS';

export enum ShareViewType {
  FitWindow = 'fit',
  OriginalSize = 'original'
}
